// Components
import MyImage from '~/components/my-image';
// Styles
import styles from './category-page-title.module.scss';

const CategoryPageTitle = ({ hasCover = true, coverImage = '', altCoverImage = '', title }) => {
  return (
    <div className={styles['wrapper']}>
      {hasCover && (
        <div className={styles['wrapper__cover']}>
          <MyImage src={coverImage} alt={altCoverImage} />
        </div>
      )}
      <h1 className={styles['wrapper__title']}>{title}</h1>
    </div>
  );
};

export default CategoryPageTitle;
